<script>
	import Router from "svelte-spa-router";
	import routes from "./routes";
	import Navbar from "./components/Navbar.svelte";
	import Footer from "./components/Footer.svelte";
	import { onDestroy, onMount } from "svelte";

	let container;

	function handleMousemove(event) {
		let mouseXpercentage =
			Math.round((event.pageX / window.innerWidth) * 10) + 35;
		let mouseYpercentage =
			Math.round((event.pageY / window.innerHeight) * 15) + 45;
		container.style.setProperty("--xp", mouseXpercentage + "%");
		container.style.setProperty("--zp", mouseYpercentage + "%");
	}

	const interval = setInterval(() => {
		let width = Math.floor(Math.random() * 300) + 100;
		let height = Math.floor(Math.random() * 400) + 100;
		container.style.setProperty("--width", width + "%");
		container.style.setProperty("--height", height + "%");
		container.style.setProperty("--opacity", (Math.floor(Math.random() * 60) + 20) + "%");
		container.style.setProperty(
			"--rotate",
			"-" + Math.floor(Math.random() * 180) + "deg"
		);
	}, 3000);

	onMount(() => (container = document.querySelector(".main")));
	onDestroy(() => clearInterval(interval));
</script>

<div class="main" on:mousemove={handleMousemove}>
	<section class="section">
		<div class="container is-max-desktop">
			<Navbar />
			<br />
		</div>
		<div class="container is-max-desktop">
			<Router {routes} />
		</div>
	</section>
	<Footer />
</div>

<style>
	.main {
		--width: 200%;
		--height: 200%;
		--rotate: -25deg;
		--xp: 40%;
		--yp: 45%;
		--zp: 50%;
		--opacity:50%;
		min-height: 100vh; /* 1 */
		display: flex; /* 2 */
		flex-direction: column; /* 3 */
		overflow: hidden;
		position: relative;
		background: linear-gradient(
			60deg,
			#0c0d0f 20%,
			rgba(4, 115, 241, 50%) 50%,
			#0c0d0f 80%
		);	

		background-size: var(--width) var(--height);

		-webkit-transition: background-size 2s ease-in-out;			
		-ms-transition: background-size 2s ease-in-out;
		transition: background-size 2s ease-in-out;
	}

	.main:before {
		opacity: 0.15;
		content: "";
		position: fixed;
		width: 400%;
		height: 200%;
		top: -50%;
		left: -150%;

		/*background: 
			radial-gradient(0 250% at var(--xp) var(--yp), #FF04F5 0%, #001AFF 100%), 
			linear-gradient(270deg, #FB00A5 80%, #0400CB var(--yp)), 
			linear-gradient(300deg, #8DADA4 0%, #32DE81 var(--yp)), 
			linear-gradient(7deg, #1DADFE 0%, #16009A 50%);
		background-blend-mode: color-dodge, color-burn, color-burn, normal; */

		background: linear-gradient(
			180deg,
			#0c0d0f var(--xp),
			#0473f1 var(--yp),
			#0c0d0f var(--zp)
		);

		background-size: var(--width) var(--height);

		-webkit-animation: bgBodyAnim 15s ease infinite;
		-moz-animation: bgBodyAnim 15s ease infinite;
		animation: bgBodyAnim 15s ease infinite;

		transform: rotate(var(--rotate));
		-ms-transform: rotate(var(--rotate));
		-webkit-transform: rotate(var(--rotate));

		-webkit-transition: -webkit-transform 3s ease-in-out,
			background-size 3s ease-in-out;
		-ms-transition: -ms-transform 3s ease-in-out,
			background-size 3s ease-in-out;
		transition: transform 3s ease-in-out, background-size 3s ease-in-out;
	}

	@-webkit-keyframes bgBodyAnim {
		0% {
			background-position: 0% 50%;
		}
		50% {
			background-position: 100% 51%;
		}
		100% {
			background-position: 0% 50%;
		}
	}
	@-moz-keyframes bgBodyAnim {
		0% {
			background-position: 0% 50%;
		}
		50% {
			background-position: 100% 51%;
		}
		100% {
			background-position: 0% 50%;
		}
	}
	@keyframes bgBodyAnim {
		0% {
			background-position: 0% 50%;
		}
		50% {
			background-position: 100% 51%;
		}
		100% {
			background-position: 0% 50%;
		}
	}

	.section {
		flex-grow: 1;
	}
</style>
